'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

var _KendoGridColumn = require('../KendoGridColumn');

var _KendoGridColumn2 = _interopRequireDefault(_KendoGridColumn);

var _GridProps = require('./GridProps');

var _GridProps2 = _interopRequireDefault(_GridProps);

var _AllowCopy = require('./AllowCopy');

var _AllowCopy2 = _interopRequireDefault(_AllowCopy);

var _ColumnMenu = require('./ColumnMenu');

var _ColumnMenu2 = _interopRequireDefault(_ColumnMenu);

var _Editable = require('./Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _Excel = require('./Excel');

var _Excel2 = _interopRequireDefault(_Excel);

var _Filterable = require('./Filterable');

var _Filterable2 = _interopRequireDefault(_Filterable);

var _Groupable = require('./Groupable');

var _Groupable2 = _interopRequireDefault(_Groupable);

var _Messages = require('./Messages');

var _Messages2 = _interopRequireDefault(_Messages);

var _NoRecords = require('./NoRecords');

var _NoRecords2 = _interopRequireDefault(_NoRecords);

var _Pageable = require('./Pageable');

var _Pageable2 = _interopRequireDefault(_Pageable);

var _Pdf = require('./Pdf');

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Scrollable = require('./Scrollable');

var _Scrollable2 = _interopRequireDefault(_Scrollable);

var _Sortable = require('./Sortable');

var _Sortable2 = _interopRequireDefault(_Sortable);

var _Toolbar = require('./Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _GridProps2.default,
    template: '<div>\n        <slot name="kendo-datasource"/>\n    </div>',
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _KendoGridColumn2.default, _AllowCopy2.default, _ColumnMenu2.default, _Editable2.default, _Excel2.default, _Filterable2.default, _Groupable2.default, _Messages2.default, _NoRecords2.default, _Pageable2.default, _Pdf2.default, _Scrollable2.default, _Sortable2.default, _Toolbar2.default],
    mounted: function mounted() {
        if (!this.widgetOptions.columns) {
            var gridColumns = [];
            if (this.$slots.default) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.$slots.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var childSlot = _step.value;

                        if (childSlot.tag && childSlot.tag.indexOf('grid-column') !== -1) {
                            gridColumns.push(childSlot.componentOptions.propsData);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            this.widgetOptions.columns = gridColumns;
        }
        kendo.jQuery(this.$el).kendoGrid(this.widgetOptions);

        this.$emit('kendowidgetready', this.kendoWidget());
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoGrid();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-grid-vue-wrapper/dist/es/KendoGrid/KendoGridMixin.js
// module id = 467
// module chunks = 45